module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_初期設定の容易さNo.1-be2ac71dfb1764ac74aa9656f84cfe09.png";